import type { z } from "zod"

import type { SbSchemaOptions } from "~/lib/storyblok/schemas"
import { sbComponent } from "~/lib/storyblok/schemas/helpers"
import { sbSizeGuideSlicesSchema } from "~/lib/storyblok/schemas/library/size-guide-slices"
import type { TSizeGuideSlice } from "~/components/slices/SizeGuideSlice/types"

export function sbComponentSizeGuideSchema(options: SbSchemaOptions) {
  return sbComponent("size_guide")
    .extend({
      items: sbSizeGuideSlicesSchema(options),
    })
    .transform(
      (data): TSizeGuideSlice => ({
        items: data.items,
      })
    )
}

export type SbComponentSizeGuide = z.infer<ReturnType<typeof sbComponentSizeGuideSchema>>
